import React from 'react';
import { useSelector } from 'react-redux';

import { appNotificationSelectors, userSelectors } from 'reducers';

import IndirectSubscription from './IndirectSubscription';
import DirectSubscription from './DirectSubscription';

const InvestorTunnel = () => {
    const tunnelSubscription = useSelector(userSelectors.getTunnelSubscription);
    const loggedIn = useSelector(userSelectors.getLoggedInStatus);
    const isCreatingSubscription = useSelector(appNotificationSelectors.isCreatingSubscription);

    if ((loggedIn && tunnelSubscription?.indirectUntransferred) || isCreatingSubscription) {
        return <IndirectSubscription />;
    }
    return <DirectSubscription />;
};

export default InvestorTunnel;
